import { TooltipCode } from 'areas/shared/consts';

const Facility = { 
    code: "Facility", 
    description: "Security Deeds, Title Deed and Property Taxes",
    tooltipCode: TooltipCode.FINANCE.FACUPLOAD 
};
const CurrentYTD = {
    code: "CurrentYTD",
    description: "Current YTD financials",
    tooltipCode: TooltipCode.FINANCE.CURRYTDUPLOAD
};
const NotesPayable = {
    code: "NotesPayable",
    description: "Notes Payable",
    tooltipCode: TooltipCode.FINANCE.NPAYABLEUPLOAD
 };
const OccupationalLicense = {
    code: "OccupationalLicense",
    description: "Occupational License",
    tooltipCode: TooltipCode.FINANCE.OCCLICUPLOAD
};
const OperatingPermits = {
    code: "OperatingPermits",
    description: "Operating Permits or License",
    tooltipCode: TooltipCode.FINANCE.OPPERUPLOAD
};
const YTDPayroll = {
    code: "YTDPayroll",
    description: "YTD Payroll - with Owners Name",
    tooltipCode: TooltipCode.FINANCE.YDTPUPLOAD
};
const BondingCapacityProof = {
    code: "BondingCapacityProof",
    description: "Proof of Bonding Capacity",
    tooltipCode: TooltipCode.FINANCE.BONDINGCUPLOAD
};

export default {
    Facility,
    CurrentYTD,
    NotesPayable,
    OccupationalLicense,
    OperatingPermits,
    YTDPayroll,
    BondingCapacityProof
};


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/financialDocuments/UploadsConfig.js